'use client';
import React from 'react';
import { ColorSwatch } from '../../../../Controls/ColorSwatch/ColorSwatch.mjs';
import { polymorphicFactory } from '../../../../factory/factory.utils.mjs';
import { Typography } from '../../../../Foundations/Typography/Typography.mjs';
import { Box } from '../../../../Other/Box/Box.mjs';
import classes from './ColorSwatches.module.css.mjs';

const ColorSwatches = polymorphicFactory(
  (props, ref) => {
    const { component = "div", colors, extraColors, selectedColor, onColorSelected, ...rest } = props;
    const colorSelected = (color) => {
      if (onColorSelected) {
        onColorSelected(selectedColor === color ? null : color);
      }
    };
    return /* @__PURE__ */ React.createElement(Box, { ref, className: classes.colorSwatchGroupContainer, component, ...rest }, colors.map((color, index) => /* @__PURE__ */ React.createElement(
      ColorSwatch,
      {
        key: index,
        className: classes.colorSwatchGroupColor,
        ...color,
        isSelected: selectedColor == color.colorName,
        onClick: () => colorSelected(color.colorName)
      }
    )), Number(extraColors) > 0 && /* @__PURE__ */ React.createElement(Typography, { className: classes.colorSwatchGroupExtraColor, size: "label-regular-m", component: "span" }, "+", extraColors));
  }
);

export { ColorSwatches };
